// @flow
import * as React from 'react';
import classnames from '@ta/common.classnames';
import type { UrlDescriptor } from '@ta/social.mentions-types';
import UrlDomain from './UrlDomain';
import UrlDescriptorLink from './UrlDescriptorLink';
import styles from './MentionsTitle.less';

type Props = {|
  title: string,
  urlDescriptor?: UrlDescriptor,
  domain?: string,
  className?: string,
  additionalTitleStyle?: boolean,
|};

const MentionsTitle = ({
  title,
  urlDescriptor,
  domain,
  className,
  additionalTitleStyle = false,
}: Props) => (
  <UrlDescriptorLink urlDescriptor={urlDescriptor} className={styles.url}>
    <span
      title={title}
      className={classnames(styles.title, className, {
        [styles.additionalTitleStyle]: additionalTitleStyle,
      })}
    >
      {title}
    </span>
    {domain ? <UrlDomain domain={domain} className={styles.domain} /> : null}
  </UrlDescriptorLink>
);

/** The MentionsTitle component */
export default React.memo<Props>(MentionsTitle);
